export const productInfoAdapter = (data) => {
	const products = data?.map((product) => {
		return {
			key: product.id_pharol,
			name: product.name,
			quantity: product.quantity,
			unit_price: product.unit_price,
			total: product.total,
			recipe: product.recipe,
			code_internal: product.code_internal,
			id_pharol: product.id_pharol,
			laboratory: product.laboratory,
			bioequivalent: product.bioequivalent,
			promotions: product.promotions,
			image: product.original_image,
			category: product.category,
			prescryption_type: product.prescryption_type,
			discount: product.valid_data_payment?.discount,
			stock: product.stock,
			total_product: product.valid_data_payment.total,
			validation_product: product?.validation_product,
		};
	});
	return products;
};
